import { WelcomeAttaches } from 'reactApp/components/WelcomeAttaches/WelcomeAttaches';
import { WelcomeAttachesRepeating } from 'reactApp/components/WelcomeAttaches/WelcomeAttachesRepeating';
import { WelcomeDialogNew } from 'reactApp/ui/WelcomeDialogNew/WelcomeDialogNew';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

import WelcomeDialogConnected from './WelcomeDialog';

export const renderWelcomeDialogHelper = renderModalDialog(WelcomeDialogConnected, 'WelcomeDialog');
export const renderWelcomeAttachesDialogHelper = renderModalDialog(WelcomeAttaches, 'WelcomeAttaches');
// tempexp_14505-next-line
export const renderWelcomeDialogNewHelper = renderModalDialog(WelcomeDialogNew, 'WelcomeDialogNew');
export const renderWelcomeRepeatingAttachesDialogHelper = renderModalDialog(WelcomeAttachesRepeating, 'WelcomeAttachesRepeating');

export default {
    renderWelcomeDialogHelper,
    renderWelcomeAttachesDialogHelper,
    // tempexp_14505-next-line
    renderWelcomeDialogNewHelper,
    renderWelcomeRepeatingAttachesDialogHelper,
};
